import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogContentText, Modal } from '@p81-common/ui';
import type { ModalProps } from '@p81-common/ui';
import CircularProgress from '@mui/material/CircularProgress';

interface ConfirmationModalProps {
  open: ModalProps['open'];
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onClose: () => void;
  isLoading?: boolean;
}

const ConfirmationModal = ({
  open,
  title,
  message,
  confirmLabel,
  onConfirm,
  onClose,
  isLoading = false
}: ConfirmationModalProps) => {
  const { t } = useTranslation('edges');
  return (
    <Modal
      id="edgeConfirmationModal"
      open={open}
      dialogActionsProps={{
        children: (
          <>
            <Button
              variant="text"
              color="primary"
              onClick={onClose}
              disabled={isLoading}
            >
              {t('CONFIRMATION_MODAL.CANCEL')}
            </Button>
            <Button color="primary" onClick={onConfirm} disabled={isLoading}>
              {isLoading && <CircularProgress size={16} sx={{ mr: 1 }} />}
              {confirmLabel}
            </Button>
          </>
        )
      }}
      dialogContentProps={{
        children: <DialogContentText>{message}</DialogContentText>
      }}
      dialogTitleProps={{
        children: title
      }}
      onClose={onClose}
    />
  );
};

export default ConfirmationModal;
